var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tabs-navigation"},_vm._l((_vm.tabs),function(ref){
var name = ref.name;
var label = ref.label;
var header = ref.header;
var active = ref.active;
var activate = ref.activate;
return _c('div',{key:name,staticClass:"tab-header",class:{ 'tab-header-active': active },on:{"click":activate}},[(header)?_c('TabHeader',{attrs:{"header":header}}):_c('div',[_vm._v(_vm._s(label))])],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }